<script>
	import TrackerBit from './TrackerBit.svelte';

	export let runningIndex = 0;
</script>

<template>
	<div class="tracker-wrapper">
		<div class="tracker">
			<TrackerBit {runningIndex} index="0" type="cross" /> 
			<TrackerBit {runningIndex} index="2" type="large" /> 

			{#each [...Array(3)] as _, index}
				<TrackerBit {runningIndex} index={index + 3} type="small" />
			{/each}

			<TrackerBit {runningIndex} index="6" type="large" /> 

			<TrackerBit {runningIndex} index="7" type="medallion" /> 

			{#each [...Array(10)] as _, index}
				<TrackerBit {runningIndex} index={index + 9} type="small" />
			{/each}

			<TrackerBit {runningIndex} index="19" type="large" />

			{#each [...Array(10)] as _, index}
				<TrackerBit {runningIndex} index={index + 23} type="small" />
			{/each}

			<TrackerBit {runningIndex} index="33" type="large" />

			{#each [...Array(10)] as _, index}
				<TrackerBit {runningIndex} index={index + 37} type="small" />
			{/each}

			<TrackerBit {runningIndex} index="47" type="large" />

			{#each [...Array(10)] as _, index}
				<TrackerBit {runningIndex} index={index + 51} type="small" />
			{/each}

			<TrackerBit {runningIndex} index="61" type="large" />

			{#each [...Array(10)] as _, index}
				<TrackerBit {runningIndex} index={index + 65} type="small" />
			{/each}

			<TrackerBit {runningIndex} index="75" type="medallion" />
		</div>
	</div>
</template>

<style lang="stylus">
	.tracker-wrapper
		height 100%

		@media only screen and (min-width: 800px)
			padding 4rem

		@media only screen and (max-width: 800px)
			padding 1rem
	
	.tracker
		width 0.5ch
		height 100%
		border-radius 999px

		display flex
		flex-direction column
		justify-content space-between
</style>
